// 总览api

import { baseRequest, fileRequest } from './base'

import store from '../vuex'

/**
 * @desc 总览数据
 */
function getTermSynopsis(params) {
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }

  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/teaTermOverview/home'
  // if (params) {
  //   tempUrl += '?'
  //   for (let key in params) {
  //     tempUrl += `${key}=${params[key]}&`
  //   }
  //   tempUrl = tempUrl.slice(0, -1)
  // }
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询学期列表
 */
function getTermList(params) {
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }

  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = 'api/pcWeb/teaTermOverview/termList'
  // if (params) {
  //   tempUrl += '?'
  //   for (let key in params) {
  //     tempUrl += `${key}=${params[key]}&`
  //   }
  //   tempUrl = tempUrl.slice(0, -1)
  // }
  return baseRequest(tempUrl, 'get', params)
}

export default {
  getTermSynopsis,
  getTermList,
}
